import Attrs from '../models/Attrs'
import type { BookMeeting } from '../models/types'

const CONTROLLER = 'components--book-meeting'
export default function renderBookMeeting(component: BookMeeting, attrs: Attrs): string {
  attrs
    .addController(CONTROLLER)
    .addValue(CONTROLLER, 'service', component.service)
    .addDOMClass(`service-${component.service}`)
    .addAction(
      `${CONTROLLER}:actions->flow#dispatchAction`,
      `${CONTROLLER}:update->flow#update`,
      `${CONTROLLER}:next->flow#next`
    )


  const loadingSpinnerAttrs = new Attrs(attrs.static_render)
    .addIcon('fa', 'spinner')
    .addTarget(CONTROLLER, 'loading')
  const containerWrapperAttrs = new Attrs(attrs.static_render).addTarget(CONTROLLER, 'container')

  switch (component.service) {
    case 'calendly': {
      attrs.addDOMClass('Calendly')
      containerWrapperAttrs.addDOMClass(`calendly-container`).add('data-auto-load', 'false')
      break
    }

    case 'hubspot': {
      containerWrapperAttrs
        .add('data-src', component.embedUrl)
        .addDOMClass('meetings-iframe-container')
      break
    }

    default:
      break
  }

  const loadingSpinner = `<svg ${loadingSpinnerAttrs}></svg>`
  const containerWrapper = `<div ${containerWrapperAttrs}></div>`

  return `<div ${attrs.toString()}>${loadingSpinner}${containerWrapper}</div>`
}
